import React from 'react';
import { useTranslation } from 'react-i18next';
import { BG_STATE_COLORS } from '../../CycleTable/constants';
import { ChannelState } from '../../../enums/channel-state.enum';
import formatTimestampFromUnix from '../../../store/models/utils/formatTimestampFromUnix';
import { DeviceActivityState } from '../../DeviceActivityState/DeviceActivityState';
import { FaultMessageList } from './components/FaultMessageList';
import { FaultedChannelProps } from './types/FaultedChannelProps';

const containerClasses = `
  c-faulted-channel border-orange-500 text-sm
  border py-3 rounded
`;
const headerClasses = `
  c-faulted-channel__header flex justify-between
  px-3 pb-2 border-b border-orange-500
`;
const bodyClasses = 'flex flex-col items-start gap-2 pt-3 px-3';
const footerClasses = 'border px-2 py-1 text-xs rounded bg-white w-full';

const FaultedChannel: React.FC<FaultedChannelProps> = ({
  channelName,
  controllerName,
  timestamp,
  isControllerConnected,
  controllerFaultMessages,
  channelFaultMessage,
}) => {
  const { t } = useTranslation();

  const renderFaultDetails = () => (
    <>
      <FaultMessageList
        title={t('faults.controllerMessagesTitle', 'Controller settings fault messages:')}
        messages={controllerFaultMessages}
      />
      <FaultMessageList
        title={t('faults.channelMessagesTitle', 'Channel fault messages:')}
        messages={channelFaultMessage}
      />
    </>
  );

  return (
    <div className={`${containerClasses} ${BG_STATE_COLORS[ChannelState.FAULTED]}`}>
      <div className={headerClasses}>
        <span>{t('terms.channel.nameWithColon', 'Channel: {{name}}', { name: channelName })}</span>
        <span>{t('terms.controller.nameWithColon', 'Controller: {{name}}', { name: controllerName })}</span>
      </div>

      <div className={bodyClasses}>
        <div className='grid grid-cols-[1fr_auto] items-center w-full'>
          <span className='text-left font-semibold'>{t('terms.controllerConnection', 'Controller connection')}:</span>
          <DeviceActivityState active={isControllerConnected} />
        </div>

        {isControllerConnected && renderFaultDetails()}

        <div className={footerClasses}>
          {formatTimestampFromUnix(timestamp)}
        </div>
      </div>
    </div>
  );
};

export default FaultedChannel;
